import { Loc } from 'main.core';
import { UserSpecificNoticeBase } from 'b24network.vue.invite-shared';
import { UserAccount } from 'b24network.vue.cross-scenario-shared-js';

/**
 * A user that not belongs to a portal with SSO authorization trying to enter this portal with SSO
 */
export class NonSsoUserOpensSsoPortal extends UserSpecificNoticeBase
{
	constructor(portalName: string, account: UserAccount)
	{
		super(
			Loc.getMessage(
				'EXT_B24NET_LOGGING_IN_NON_SSO_USER_ENTERS_SSO_PORTAL',
				{
					'[b]': '<b>',
					'[/b]': '</b>',
					'[br]': '<br>',
					'#PORTAL_NAME#': portalName,
				},
			),
			account,
			Loc.getMessage('EXT_B24NET_LOGGING_IN_YOU_ARE_AUTHORIZED'),
		);
	}
}
